var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-circular',{attrs:{"size":_vm.size,"value":_vm.workload,"color":_vm.workloadColor}},[_vm._v(" "+_vm._s(_vm.capacityUsed)+" / "+_vm._s(_vm.capacity)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }